import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getTextFieldUtilityClass(slot) {
  return generateUtilityClass('JoyTextField', slot);
}
const textFieldClasses = generateUtilityClasses('JoyTextField', ['root', 'disabled', 'error', 'focused', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'sizeSm', 'sizeMd', 'sizeLg', 'variantPlain', 'variantOutlined', 'variantSoft', 'fullWidth']);
export default textFieldClasses;